import React from 'react'

import { TtButton } from '@23/ui-react'

import './ChatReactionsSelector.scss'

const REACTIONS = ['👏', '👍', '❤️', '😃', '💡']

interface ChatReactionsSelectorProps {
  onReactionSelected: (reaction: string) => void
}

const ChatReactionsSelector = ({
  onReactionSelected,
}: ChatReactionsSelectorProps) => {
  return (
    <div className="reactions-selector">
      {REACTIONS.map((reaction) => {
        return (
          <TtButton
            className="reaction"
            color="secondary"
            variant="ghost"
            key={reaction}
            onClick={() => onReactionSelected(reaction)}
            circle
          >
            <span>{reaction}</span>
          </TtButton>
        )
      })}
    </div>
  )
}

export { ChatReactionsSelector }
